
<script>
export default {
    name: "CapeIntro",
    template: "#templateIntro"
}
</script>
